import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var TicketIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M15.914 1l1.282 1.281a2 2 0 01.452 2.132c-.164.426-.074.755.37 1.17.475.446.903.543 1.442.349a2 2 0 012.046.422l1.418 1.329a2 2 0 01.09 2.827l-.057.059-6.25 6.138-5.793 5.793a2 2 0 01-2.828 0l-1.411-1.411a2 2 0 01-.56-1.741c.133-.797.01-1.309-.322-1.64-.332-.333-.844-.456-1.64-.324a2 2 0 01-1.742-.559l-1.384-1.384a2 2 0 010-2.829c.026-.026.026-.026.053-.05L7.306 6.78 13.086 1a2 2 0 012.828 0zM14.5 2.414l-2.84 2.838.047.04 1 1a1 1 0 01-1.32 1.498l-.094-.083-1-1a1.016 1.016 0 01-.042-.044L8.707 8.207l-.027.026-6.24 5.794 1.385 1.384c1.387-.23 2.55.049 3.382.882.833.833 1.112 1.995.882 3.382l1.411 1.41 5.8-5.798 1.802-1.772-.81-.808a1 1 0 01-.082-1.32l.083-.094a1 1 0 011.414 0l.822.821 3.027-2.972-1.418-1.329c-1.26.455-2.476.179-3.489-.771s-1.336-2.128-.868-3.346L14.5 2.414zm.113 5.796l.094.083 1 1a1 1 0 01-1.32 1.497l-.094-.083-1-1a1 1 0 011.32-1.497z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
TicketIcon.isCarinaIcon = true;
export default TicketIcon;
